import type { ThemeVariantMap } from "@/theme/types";

import { urbanKitchenLightTheme } from "./urbanKitchen.light";

export const urbanKitchenTheme: ThemeVariantMap = {
  LIGHT: urbanKitchenLightTheme,
} as const;
